/* eslint-disable react/destructuring-assignment */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import {
  setDetailsScreenTab,
  dispatchUnderThresholdSearch,
  selectedIndex,
} from '../../store/Actions';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';
import CustomSelect from '../../../../../SharedModules/CustomSelectBox/CustomSelect';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';

export default (props) => {
  // handing Onchange event & check validation on filed level
  const dispatch = useDispatch();
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const detailScreenTabData = useSelector(
    (state) => state.sharedState.UnderThresholdInvoiceReducer?.detailsScreenObj
  );
  const underThresholdSearchList = useSelector((state) =>
    state.sharedState.UnderThresholdInvoiceReducer?.underThresholdSearchList?.sort(
      (a, b) => a.mfgId - b.mfgId
    )
  );
  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  const handleChangeSelect = (e) => {
    let localErr = detailScreenTabData?.errorMessages || [];
    const newObj = [...underThresholdSearchList];
    if (e.target.value === null || e.target.value === '-1') {
      localErr = localErr.filter(
        (item) => item.errorType !== `invoiceHadingCd${props.rowIndex}`
      );
      localErr.push({
        field: 'invoiceHadingCd',
        errorType: `invoiceHadingCd${props.rowIndex}`,
        message: constantMessageData.HANDING_CODE_REQUIRED,
      });
      newObj[props?.data?.key].invoiceHandlingCdErr = true;
      newObj[props?.data?.key].isUpdate = true;
      newObj[props?.data?.key].invoiceHandlingCd = e.target.value;
      props.node.setDataValue(props?.column.colId, e.target.value);
      dispatch(
        setDetailsScreenTab({
          ...detailScreenTabData,
          disabledSaveCancelBtn: false,
          successMessages: [],
          errorMessages: [...new Set(localErr)],
        })
      );
      dispatch(dispatchUnderThresholdSearch(newObj));
    } else {
      localErr = localErr.filter(
        (item) => item.errorType !== `invoiceHadingCd${props.rowIndex}`
      );
      newObj[props?.data?.key].invoiceHandlingCdErr = false;
      newObj[props?.data?.key].isUpdate = true;
      newObj[props?.data?.key].invoiceHandlingCd = e.target.value;
      props.node.setDataValue(props?.column.colId, e.target.value);
      dispatch(
        setDetailsScreenTab({
          ...detailScreenTabData,
          disabledSaveCancelBtn: false,
          successMessages: [],
          errorMessages: [...new Set(localErr)],
        })
      );
      dispatch(selectedIndex(newObj[props?.data?.key]?.key));
      dispatch(dispatchUnderThresholdSearch(newObj));
    }
  };
  return (
    <div data-testid="check-log-select-box ">
      <TextField
        id={`underthreshold${props.data.key}`}
        label={`underthreshold${props.data.key}`}
        className={
          underThresholdSearchList &&
          underThresholdSearchList[props?.data.key] &&
          underThresholdSearchList[props?.data.key].invoiceHandlingCdErr !==
            undefined &&
          underThresholdSearchList[props?.data.key].invoiceHandlingCdErr
            ? 'td-active-cell tBill-validate frr-display-hidden-label'
            : 'frr-display-hidden-label'
        }
        fullWidth
        select
        disabled={
          !(props.data.invoiceFreezeDate === null) ||
          props?.isReadOnly ||
          isEnablebyRole
        }
        placeholder=""
        inputProps={{ id: `underthreshold${props.data.key}` }}
        InputLabelProps={{
          shrink: true,
        }}
        value={props?.value ? props.value : '-1'}
        onChange={(e) => {
          handleChangeSelect(e);
        }}
      >
        <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
        {props?.dropdownListForHandingCode?.map((item) => {
          return (
            <MenuItem
              key={item.codeValueID && item.codeValueID.codeValue}
              value={item.codeValueID && item.codeValueID.codeValue}
            >
              {`${item.codeValueID && item.codeValueID.codeValue} | ${
                item.shortDescription
              }`}
            </MenuItem>
          );
        })}
      </TextField>
    </div>
  );
};
